import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class ReembolsoMedicoService extends Service {
  async consultarReembolsos (numProtocolo, numMatricula, seqPrestador, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal) {
    let reembolsos = [];
    let brancoAcoes = '';
    let result = await this.getReembolsoMedicoApi().consultarReembolsos(numProtocolo, numMatricula, seqPrestador, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal);
    result.map(res => {
      const { numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, seqPrestador, nomPrestador, numProcesso, anoProcesso, numNf, numSerieNf, dtaNf, valNf, valReembolso, valDeducao, txtObservacao, codUsuarioCadastro, dtaCadastro, anoPag, mesPag, codTipoPag, indAcerto, codEstado, desEstado, seqRubrica, txtProcessoSei, historicos, numCpfCgc } = res;
      const numAnoProc = numProcesso + '/' + anoProcesso;
      reembolsos.push(Object.values({ numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, seqPrestador, nomPrestador, numAnoProc, numProcesso, anoProcesso, numNf, numSerieNf, dtaNf, valNf, valReembolso, valDeducao, txtObservacao, codUsuarioCadastro, dtaCadastro, anoPag, mesPag, codTipoPag, indAcerto, codEstado, desEstado, seqRubrica, txtProcessoSei, historicos, numCpfCgc, brancoAcoes }));
    });
    return reembolsos || [];
  }
  async incluirReembolso (reembolso) {
    let result = await this.getReembolsoMedicoApi().incluirReembolso(reembolso);
    return result;
  }
  async alterarReembolso (reembolso) {
    let result = await this.getReembolsoMedicoApi().alterarReembolso(reembolso);
    return result;
  }
  async excluirReembolso (numProtocolo) {
    let result = await this.getReembolsoMedicoApi().excluirReembolso(numProtocolo);
    return result;
  }
  async consultarNomePrestador (CPF_CNPJ) {
    let result = await this.getReembolsoMedicoApi().consultarNomePrestador(CPF_CNPJ);
    return result;
  }    
}
export default ReembolsoMedicoService;
